import { render, staticRenderFns } from "./ChatChannelTabs.vue?vue&type=template&id=311c4599&scoped=true&lang=pug&"
import script from "./ChatChannelTabs.vue?vue&type=script&lang=js&"
export * from "./ChatChannelTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChatChannelTabs.vue?vue&type=style&index=0&id=311c4599&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c4599",
  null
  
)

component.options.__file = "ChatChannelTabs.vue"
export default component.exports